<template>
    <div class="margin_recharge">
        <div class="box">
            <div class="box_item" :class="{'active': index == 1}" @click="changeIndex(1)">&yen;150</div>
            <div class="box_item" :class="{'active': index == 2}" @click="changeIndex(2)">&yen;300</div>
            <div class="box_item" :class="{'active': index == 3}" @click="changeIndex(3)">&yen;450</div>
            <div class="box_item" :class="{'active': index == 4}" @click="changeIndex(4)">&yen;600</div>
            <div class="box_item" :class="{'active': index == 5}" @click="changeIndex(5)">&yen;750</div>
            <div class="box_item" :class="{'active': index == 6}" @click="changeIndex(6)">&yen;900</div>
            <div class="box_item ipt" :class="{'active': index == 7}" @click="changeIndex(7)">
                <span class="yen">&yen;</span>
                <el-input type="number" placeholder="请输入150的倍数" v-model="ipt_amount" @blur="blur" />
                <div class="error" v-if="err != ''">{{ err }}</div>
            </div>
            <div class="trade_type">
                <span>支付方式：</span>
                <p><img src="../assets/bx/alipay.png" alt="" />支付宝</p>
            </div>
        </div>

        <van-button round color="var(--theme)" :disabled="disabled" :loading="loading" class="re_btn" @click="recharge">
            充值</van-button>
    </div>
</template>

<script>
    import crypto from "crypto";
    import Fingerprint2 from 'fingerprintjs2'
    export default {
        name: 'margin-recharge',
        data() {
            return {
                err: '',
                ipt_amount: '', //自定义金额
                amount: '', //金额
                index: null,
                disabled: true,
                loading: false,
                pay_type: 'alipay',
                scene: 'wap',
            }
        },
        computed: {
            access_token() {
                return this.$store.state.access_token
            }
        },
        created() {},
        mounted() {},
        methods: {
            changeIndex(index) {
                this.index = index;

                if (this.index == 1) {
                    this.amount = 150;
                    this.disabled = false
                    this.err = ''
                } else if (this.index == 2) {
                    this.amount = 300
                    this.disabled = false
                    this.err = ''
                } else if (this.index == 3) {
                    this.amount = 450
                    this.disabled = false
                    this.err = ''
                } else if (this.index == 4) {
                    this.amount = 600
                    this.disabled = false
                    this.err = ''
                } else if (this.index == 5) {
                    this.amount = 750
                    this.disabled = false
                    this.err = ''
                } else if (this.index == 6) {
                    this.amount = 900
                    this.disabled = false
                    this.err = ''
                } else if (this.index == 7) {
                    if (this.ipt_amount == '') {
                        this.disabled = true
                    } else {
                        if (Number(this.ipt_amount) % 150 != 0) {
                            this.err = '请输入150的倍数'
                            this.disabled = true
                        } else {
                            this.disabled = false
                        }
                    }
                }
            },
            blur(e) {
                if (this.ipt_amount == '') {
                    if(this.index != 7) {
                        this.err = '请输入金额'
                    }
                    this.disabled = true
                } else {
                    if (Number(this.ipt_amount) % 150 != 0) {
                        this.err = '请输入150的倍数'
                        this.disabled = true
                    } else {
                        this.disabled = false
                    }
                }
            },
            async getUdid() {
                var that = this
                const fp = await new Promise((resolve) => {
                    Fingerprint2.get((components) => {
                        const values = components.map((component, index) => {
                            if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不     一样
                                return component.value.replace(/\bNetType\/\w+\b/, '')
                            }
                            return component.value
                        })
                        // 生成最终id murmur 
                        // console.log(values,'使用的浏览器信息')  //使用的浏览器信息
                        const udid = Fingerprint2.x64hash128(values.join(''), 31)
                        // console.log(udid,'生成的标识码') //生成的标识码
                        that.udid = udid
                        resolve(udid);
                    })
                })
                return fp;
            },
            uuid() {
                var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8,
                1); // bits 6-7 of the      clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                return uuid;
            },
            MD5(value) {
                return crypto.createHash("md5").update(value).digest("hex");
            },
            sign(params = {}) {
                const keys = Object.keys(params).sort();
                const signs = [];
                for (let key of keys) {
                    if (params[key] == null) continue;
                    signs.push(key + '=' + params[key]);
                }
                return this.MD5(signs.join("&") + 'AfkRZKZs2LxuscnNUbpQrWppJvx48GEg');
            },
            async recharge() {
                var that = this
                await this.getUdid()
                if (this.index == 7) {
                    this.amount = this.ipt_amount
                }
                this.loading = true
                await this.$Ajax('order/user-balance', {
                    amount: this.amount,
                    otype: 2
                }).then(rs => {
                    if (rs.code == 200) {
                        if (rs.data.order_num != '') {
                            this.$Ajax('pay/pay', {
                                orderNum: rs.data.order_num,
                                payType: this.pay_type,
                                scene: this.scene,
                                type: 'balance'
                            }).then(res => {
                                if (res.code == 200) {
                                    if (res.data.type == 'redirect') {
                                        var timestamp = Date.parse(new Date()) / 1000
                                        var uuids = this.uuid();
                                        const request_id = this.MD5(that.access_token + uuids + timestamp);
                                        var udid = this.udid
                                        var sign = this.sign({
                                            orderNum: rs.data.order_num,
                                            scene: this.scene,
                                            type: 'balance',
                                            udid,
                                            request_id,
                                            timestamp,
                                        })
                                        window.location.href = this.$BaseURL + res.data.url + '&udid=' + udid + '&request_id=' + request_id + '&timestamp=' + timestamp + '&sign=' + sign
                                    }
                                }
                            }).finally(() => {
                                setTimeout(() => {
                                    this.loading = 0
                                }, 2000)
                            })
                        }
                    } else if (rs.code == 602) {
                        this.$router.push({
                            name: 'user.identity'
                        })
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false
                    },2000)
                })
            },
        },
        watch: {
            ipt_amount: {
                immediate: true,
                handler(e) {
                    if (e != '') {
                        if (Number(e) % 150 == 0) {
                            this.err = ''
                            this.disabled = false
                        } else {
                            this.disabled = true
                        }
                    }
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .margin_recharge {
        .box {
            background-color: #fff;
            border-radius: 1rem;
            padding: 2rem 1rem;
            display: flex;
            flex-wrap: wrap;

            .box_item {
                width: 29%;
                height: 3.8rem;
                background-color: #f5f5f5;
                font-size: 1.4rem;
                color: #000;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: .4rem;
                border-radius: .8rem;
                border: 1px solid #fff;

                &:nth-child(3n+2) {
                    margin: 0 6.5%;
                }

                &.active {
                    border-color: var(--theme);
                    background-color: var(--themebgc);
                }

                &.ipt {
                    width: 100%;
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding: 0 1.2rem;

                    .yen {
                        font-size: 1.2rem;
                        width: 1.6rem;
                    }

                    /deep/.el-input {
                        flex: 1;
                        padding: 0;
                        margin: 0;
                        font-size: 1.4rem;
                        color: #000;

                        .el-input__inner {
                            padding: 0 1.6rem 0 0;
                            margin: 0;
                            border: none;
                            box-shadow: none;
                            background-color: transparent;
                            text-align: center;

                            &::placeholder {
                                color: #999;
                            }
                        }
                    }

                    .error {
                        position: absolute;
                        bottom: -2rem;
                        right: 0;
                        font-size: 1.2rem;
                        color: var(--red);
                    }
                }
            }

            .trade_type {
                margin-top: 2.5rem;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                span {
                    font-size: 1.4rem;
                    color: #000;
                    font-weight: 700;
                }

                p {
                    display: flex;
                    align-items: center;
                    font-size: 1.4rem;
                    color: #000;

                    img {
                        width: 1.6rem;
                        height: 1.6rem;
                        margin-top: 0.25rem;
                        margin-right: .4rem;
                    }
                }
            }
        }

        .re_btn {
            width: 100%;
            height: 3.2rem;
            font-size: 1.6rem;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 2rem 0;

            &:disabled {
                background-color: #999 !important;
                border-color: #999 !important;
            }
        }
    }
</style>